import {
  AppBar,
  Toolbar,
  Button,
  Stack,
  Box,
  IconButton,
  Drawer, 
  List,
  ListItem,
  ListItemButton,
  ListItemText 
  
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { COLORS } from "../theme/theme";
import logo from "../assets/logo.png";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Benefits", to: "/benefits" },
  { label: "How to Use", to: "/how-to-use" },
  { label: "Compare", to: "/compare" },
  { label: "Contact", to: "/contact" }
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <AppBar position="sticky" elevation={0} color="transparent">
        <Toolbar sx={{ justifyContent: "space-between" ,backgroundColor:COLORS.while}}>
          
          {/* LOGO */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              textDecoration: "none",
              color: "inherit"
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="RK Farm Logo"
              sx={{
                height: 100,              // responsive-friendly
                width: "auto",
                objectFit: "contain"
              }}
            />

            {/* <Typography variant="h6" fontWeight={700}>
              RK Farm
            </Typography> */}
          </Box>

          {/* DESKTOP MENU */}
          <Stack
            direction="row"
            spacing={4}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            {navItems.map((item) => (
              <NavItem key={item.to} to={item.to} label={item.label} />
            ))}
          </Stack>

          {/* DESKTOP LOGIN */}
          <Box>
          {/* <Button
            variant="contained"
            component={Link}
            // to="/auth/login"
            sx={{ display: { xs: "none", md: "inline-flex" },backgroundColor:"#fff",border:'none' }}
          >
            Login
          </Button> */}
          </Box>
          

          {/* MOBILE MENU ICON */}
          <IconButton
            sx={{ display: { xs: "inline-flex", md: "none" } }}
            onClick={() => setOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box sx={{ width: 260 }} role="presentation">
          <List>
            {navItems.map((item) => (
              <ListItem key={item.to} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  sx={{
                    "&.active .MuiListItemText-primary": {
                      color: "#1F4D2B",
                      fontWeight: 700
                    }
                  }}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          {/* <Box px={2} mt={2}>
            <Button
              fullWidth
              variant="contained"
              component={Link}
              to="/auth/login"
              onClick={() => setOpen(false)}
            >
              Login
            </Button>
          </Box> */}
        </Box>
      </Drawer>
    </>
  );
}

/* DESKTOP NAV ITEM */
function NavItem({ to, label }) {
  return (
    <Button
      component={NavLink}
      to={to}
      sx={{
        color: "#1F4D2B",
        fontWeight: 600,
        "&.active": {
          borderBottom: "2px solid #1F4D2B",
          borderRadius: 0
        }
      }}
    >
      {label}
    </Button>
  );
}
